import {
    addDays as addDaysFn,
    addMonths as addMonthsFn,
    addYears as addYearsFn,
    differenceInDays as differenceInDaysFn,
    format as formatFn,
    getDate,
    getYear,
    isAfter as isAfterFn,
    isBefore as isBeforeFn,
    isSameDay as isSameDayFn,
    isSameMonth as isSameMonthFn,
    parse,
    set,
    startOfDay as startOfDayFn,
    startOfMonth as startOfMonthFn,
    subDays as subDaysFn,
    subMonths as subMonthsFn,
    subYears as subYearsFn,
    differenceInMonths as differenceInMonthsFn,
    startOfYear as startOfYearFn,
    isEqual,
    isValid
} from 'date-fns';
import { IDateService } from '../../interface/date.interface';

export class DateFnsDateService extends Date implements IDateService {
    constructor(date: Date | string | number, parseString?: string) {
        if (!!parseString && typeof date === 'string') {
            super(parse(date, parseString, new Date()));
            return;
        }

        super(date);
    }

    public addDays(days: number): this {
        const _date = addDaysFn(this, days);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public addMonths(months: number): this {
        const _date = addMonthsFn(this, months);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public addYears(years: number): this {
        const _date = addYearsFn(this, years);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public subtractDays(days: number): this {
        const _date = subDaysFn(this, days);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public subtractMonths(months: number): this {
        const _date = subMonthsFn(this, months);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public subtractYears(years: number): this {
        const _date = subYearsFn(this, years);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public format(format: string = 'EEE MMM dd yyyy'): string {
        // `toISOString` throws `RangeError: Invalid time value` on an invalid date,
        // so mirror BasicDateService and return 'Invalid Date' instead.
        if (!isValid(this)) {
            return 'Invalid Date';
        }

        return formatFn(new Date(this.getTime()), format);
    }

    public toDate(): Date {
        return this;
    }

    public override getDay(): number {
        return getDate(this);
    }

    public getYear(): number {
        return getYear(this);
    }

    public setDates(date: number): this {
        const _date = set(this, { date });
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public setMonths(month: number): this {
        const _date = set(this, { month });
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public setYears(year: number): this {
        const _date = set(this, { year });
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public startOfDay(): this {
        const _date = startOfDayFn(this);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public startOfMonth(): this {
        const _date = startOfMonthFn(this);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public startOfYear(): this {
        const _date = startOfYearFn(this);
        // @ts-ignore
        return new DateFnsDateService(_date);
    }

    public isSameDay(date: this): boolean {
        return isSameDayFn(this, date.toDate());
    }

    public isSameMonth(date: this): boolean {
        return isSameMonthFn(this, date.toDate());
    }

    public isBefore(date: this): boolean {
        return isBeforeFn(this, date);
    }

    public isAfter(date: this): boolean {
        return isAfterFn(this, date);
    }

    public isSameOrBefore(date: this | Date): boolean {
        return isBeforeFn(this, date) || isEqual(this, date);
    }

    public differenceInDays(date: this | Date): number {
        return differenceInDaysFn(this, date);
    }

    public differenceInMonths(date: this | Date): number {
        return differenceInMonthsFn(this, date);
    }
}
